import { useState } from "react";
import { NavLink } from "react-router-dom";
import { HiMenu, HiX } from "react-icons/hi";

const navItems = [
  { path: "/", label: "🏠 Home" },
  { path: "/about", label: "👤 About" },
  { path: "/skills", label: "💻 Skills" },
  { path: "/services", label: "🛠 Services" },
  { path: "/projects", label: "📁 Projects" },
  { path: "/contact", label: "📬 Contact" },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDark ] = useState(true); // for future theme toggle

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav
      className={`w-full fixed top-0 z-50 transition-colors duration-300 backdrop-blur-md shadow-md ${
        isDark
          ? "bg-gradient-to-b from-gray-950/90 to-gray-900/60 text-white"
          : "bg-white/80 text-black"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
        {/* Logo or Brand */}
        <div className="text-xl font-bold tracking-wide">
          <NavLink to="/" onClick={() => setIsOpen(false)}>
            🚀 Harsh's Portfolio
          </NavLink>
        </div>

        {/* Desktop Nav Links */}
        <div className="hidden md:flex gap-6 text-sm font-semibold tracking-wide">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `relative transition duration-300 ease-in-out pb-1 border-b-2 border-transparent hover:border-current ${
                  isActive ? "font-bold border-current" : ""
                }`
              }
            >
              <span className="inline-block after:block after:h-[2px] after:bg-current after:scale-x-0 after:transition-transform after:duration-300 after:origin-left hover:after:scale-x-100">
                {item.label}
              </span>
            </NavLink>
          ))}
        </div>

        {/* Mobile Hamburger */}
        <button
          onClick={toggleMenu}
          className="md:hidden text-2xl p-2 text-white focus:outline-none"
        >
          {isOpen ? <HiX /> : <HiMenu />}
        </button>
      </div>

      {/* Mobile Dropdown */}
      {isOpen && (
        <div className="md:hidden px-4 pb-6 pt-2 flex flex-col gap-4 text-base font-medium text-center bg-gray-900/90 text-white">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={() => setIsOpen(false)}
              className={({ isActive }) =>
                `py-2 rounded transition ${
                  isActive
                    ? "text-emerald-400 font-semibold"
                    : "hover:text-emerald-300"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
